import { render, staticRenderFns } from "./JumpcloudGoButton.vue?vue&type=template&id=12df4d72&scoped=true&"
import script from "./JumpcloudGoButton.vue?vue&type=script&lang=js&"
export * from "./JumpcloudGoButton.vue?vue&type=script&lang=js&"
import style0 from "./JumpcloudGoButton.vue?vue&type=style&index=0&id=12df4d72&prod&scoped=true&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "12df4d72",
  null
  
)

export default component.exports